import React from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { withTranslation } from 'react-i18next';

import Product from '../product/Product';
import Price from '../price/Price';


class Basket extends React.Component {

    state = {
        visible: false
    }

    componentDidMount() {
        const { handleClickOutside} = this;
        document.addEventListener('click', handleClickOutside, true);
        //getBasketItems();
    }

    componentWillUnmount() {
        const {handleClickOutside} = this;
        document.removeEventListener('click', handleClickOutside, true);
    }

    handleClickOutside = event => {
        const domNode = ReactDOM.findDOMNode(this.refs.basketItems);
        
        this.setState({
            visible: (domNode && domNode.contains(event.target))
        });
    }
    
    handleShowBasket = event => {
        event.preventDefault();
        this.setState({
            visible: true
        });
    }
    
    handleClick = () => {
        const {state: {visible}} = this;
        this.setState({
            visible: !visible
        });
    }

    render() {
        return (
            <React.Fragment>        
                <a href={this.props.settings.links.basketLink} onMouseOver={this.handleShowBasket} > 
                    <i className="glyphicon glyphicon-shopping-cart"></i> 
                    <b><Price 
                        valueEUR={this.props.basket.totalPriceWithVat} 
                        valueCZK={this.props.basket.totalPriceCZKWithVat}  
                    /></b> 
                </a>       
                {!this.props.settings.flagInBasket && <React.Fragment>
                    {this.state.visible && (!this.props.search.results || this.props.search.results.length === 0) && <React.Fragment>
                        {this.props.basket.items && this.props.basket.items.length > 0 &&     
                            <div ref="basketItems" id="basket" className="bbb-overlay" >
                                <h4>{ this.props.t( 'basket.content' ) }
                                    <a onClick={this.handleClick} className="closeBtn"><span className="glyphicon glyphicon-remove "></span></a>
                                </h4>
                                <ul className="product-list">
                                    {this.props.basket.items.map( item => {
                                        return <Product key={item.id} qty={item.qty} product={item.product} />;
                                    })}
                                </ul>
                                <div className="footer">
                                    <a href={this.props.settings.links.basketLink} className="btn btn-sm btn-basket plus">
                                        { this.props.t( 'basket.goToBasket' ) }<i className="glyphicon glyphicon-menu-right"></i>
                                    </a>
                                </div>
                            </div>
                        }      
                        </React.Fragment>        
                    }
                    </React.Fragment>        
                }
            </React.Fragment>
            );
    }

}

const mapStateToProps = (state) => ({
    search: state.search,
    basket: state.basket,
    settings: state.settingsReducer
});

const mapDispatchToProps = (dispatch) => bindActionCreators({

}, dispatch );

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()( Basket ));